
import HeaderDashboard from '../Components/HeaderDashboard';



const Settings = () => {
  return(
    <>
    <HeaderDashboard></HeaderDashboard>
     <div className="toolbar py-2" id="kt_toolbar">
                <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1 flex-shrink-0 me-5">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                            <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Settings</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
										<li class="breadcrumb-item text-muted">Settings</li>
										
									</ul>
                        </div>
                    </div>

                </div>
            </div>

            <section className='wraper'>
                <div className='row mt-14 p-0'>
                    <div class="col-md-3 mb-3">
                        <div class="box_shadow">
                            <img src="/assets/images/Suppliers.png" alt="img" class="img-fluid img-icon" />
                            <img src="/assets/images/img-status-5.svg" alt="img" class="img-fluid img-bg" />
                            <a href="/settings/Manage">
                                <h5>Manage</h5>
                                <p>Change/Update Password</p>
                                <i class="fa-solid fa-arrow-right"></i>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-3 mb-3">
                        <div class="box_shadow">
                            <img src="/assets/images/Customers.png" alt="img" class="img-fluid img-icon" />
                            <img src="/assets/images/img-status-5.svg" alt="img" class="img-fluid img-bg" />
                            <a href="/settings/Myprofile">
                                <h5>My profile</h5>
                                <p>View/Update profile</p>
                                <i class="fa-solid fa-arrow-right"></i>
                            </a>
                        </div>
                    </div>

                </div>
            </section>
        </>
    );
};

export default Settings;